export const HeaderMenu = [
  {
    title: "list",
    path: "/",
  },
  // {
  //   title: "interactions",
  //   path: "/interactions",
  // },
  {
    title: "create",
    path: "/create",
  },
  {
    title: "positions",
    path: "/positions",
  },
  {
    title: "howItWorks",
    path: "/how-it-works",
  },
];

export const HeaderConnect = {
  title: "Connect Wallet",
  path: "/",
};
